import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { combineLatest, map } from "rxjs";

import { AuthService } from "src/app/core";
import { CompaniesService, MembershipsService } from "src/app/features/admin";

export const myRequestsTabsResolver: ResolveFn<unknown> = (route, state) => {
  const companiesService = inject(CompaniesService);
  const membershipsService = inject(MembershipsService);
  const authService = inject(AuthService);
  const userId = authService.userId()!;

  const tabs: unknown[] = [];

  const myCompanyRequests = companiesService.getPaged({
    pageNumber: 1,
    pageSize: 10,
    filter: { createdUserId: userId },
    orderByValue: [{ colId: "CreatedDate", sort: "desc" }],
  });

  const myMembershipRequests = membershipsService.getPaged({
    pageNumber: 1,
    pageSize: 10,
    filter: { userId },
    orderByValue: [{ colId: "CreatedDate", sort: "desc" }],
  });

  return combineLatest([myCompanyRequests, myMembershipRequests]).pipe(
    map(([companies, memberships]) => {
      if (companies.totalCount > 0)
        tabs.push({
          key: "MyCompanyRequest",
          title: "COMPANIES.MY_COMPANY_REQUEST",
          routerLink: "my-company-request",
        });

      if (memberships.totalCount > 0)
        tabs.push({
          key: "MyMembershipRequest",
          title: "FRIENDS_OF_OMAN_MUSEUM.MEMBERSHIP_REQUEST",
          routerLink: "my-membership-request",
        });

      return tabs;
    }),
  );
};
